export default class DeliveryQueue {
  constructor() {
    this.itemList = [];

    // deliverCoord 需要移進來裡面嗎？
  }

  addItems(items) {
    if (Array.isArray(items)) {
      this.itemList = [...this.itemList, ...items];
      return;
    }
    this.itemList.push(items);
  }

  getList() {
    return this.itemList;
  }

  updateList(itemList) {
    this.itemList = itemList;
  }
}
